import { useIsRecurly } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import useVindiciaCouponQuery from './useVindiciaCouponQuery'
import useRecurlyCouponQuery from './useRecurlyCouponQuery'


type UseCouponProductProps = {
  coupon: string
  skip?: boolean
}

type ReturnType = {
  product: GiftOfferModal.ProductType
  isFetching: boolean
  fetch: () => void
}


const useCouponProduct = ({ coupon, skip }: UseCouponProductProps): ReturnType => {
  const { gender, plan } = useConnect({
    gender: 'models.me.gender',
    plan: 'models.subscription.currPlan.name',
  })

  const isRecurly = useIsRecurly()

  const vindiciaCoupon = useVindiciaCouponQuery({
    coupon,
    gender,
    plan,
    skip: skip || isRecurly,
  })

  const recurlyCoupon = useRecurlyCouponQuery({
    coupon,
    skip: skip || !isRecurly,
  })

  return isRecurly ? recurlyCoupon : vindiciaCoupon
}


export default useCouponProduct
